module.exports = __webpack_public_path__ + "static/media/calculator.1e957ff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/SSP/calculator.png
// module id = 251
// module chunks = 0